import React from 'react';
import classNames from 'classnames';
import { NSRadioOption, NSButton, NSDropdown } from 'bricks';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { DealFromSignup } from 'views/ProFormaTable/hooks/useGetDealsWithProFormas';

interface ImportUsesOptionProps {
    deal: DealFromSignup;
    isLast: boolean;
    selectedDealId?: number | null;
    handleDealSelect: (dealId: number) => void;
    selectedProFormaId?: number | null;
    handleProFormaSelect: (proFormaId: number) => void;
    onCopyBudgetCategorizations?: (dealId: number, proFormaId: number) => void;
}

const ImportUsesOption: React.FC<ImportUsesOptionProps> = ({
    deal,
    isLast,
    selectedDealId,
    handleDealSelect,
    selectedProFormaId,
    handleProFormaSelect,
    onCopyBudgetCategorizations,
}) => {
    const isSelected = deal.id === selectedDealId;

    const proFormaOptions = deal.proFormas.map(pf => ({
        value: pf.id,
        label: pf.name,
    }));

    const handleDealClick = () => {
        handleDealSelect(deal.id);

        if (deal.proFormas.length === 1) {
            handleProFormaSelect(deal.proFormas[0].id);
        }
    };

    const handleAddClick = () => {
        if (selectedProFormaId && onCopyBudgetCategorizations) {
            onCopyBudgetCategorizations(deal.id, selectedProFormaId);
        }
    };

    return (
        <div>
            <div
                className={classNames('ImportSourceListItem cursor--pointer p-2', {
                    'ImportSourceListItem--selected': isSelected,
                })}
                onClick={handleDealClick}
                role="presentation"
            >
                <div
                    className={classNames('d-flex', {
                        'align-items-start': isSelected,
                        'align-items-center': !isSelected,
                    })}
                >
                    <div className="mr-2">
                        <NSRadioOption
                            id={`radio-${deal.id}`}
                            name="dealSelection"
                            checked={isSelected}
                            onChange={() => handleDealSelect(deal.id)}
                            label=""
                        />
                    </div>
                    <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <div className="text-white font-weight-bold">{deal.dealName}</div>
                                {/* TODO get date from API */}
                                <div className="text-muted font-12">Created Jan 3, 2025</div>
                            </div>
                            {isSelected && (
                                <NSButton
                                    text="Add"
                                    color="primary"
                                    icon={faAngleRight}
                                    iconPosition="right"
                                    className="px-3"
                                    disabled={!selectedProFormaId}
                                    callback={handleAddClick}
                                />
                            )}
                        </div>
                        {isSelected && (
                            <div className="mt-2">
                                <div className="separator mb-2" />
                                <div className="d-flex justify-content-between">
                                    <div style={{ width: '320px' }}>
                                        <div className="text-white mb-1">
                                            Pro Forma
                                            <span className="text-danger pl-1">*</span>
                                        </div>
                                        <NSDropdown
                                            options={proFormaOptions}
                                            placeholder="Select pro forma"
                                            handleSelectOption={option => handleProFormaSelect(option?.value as number)}
                                            selectedOption={proFormaOptions.find(opt => opt.value === selectedProFormaId)}
                                            isFullWidth
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {!isSelected && !isLast && <div className="separator" />}
        </div>
    );
};

export default ImportUsesOption;
